import { createContext, ReactNode, useMemo } from 'react'
import { createHtmlPortalNode, HtmlPortalNode, InPortal } from 'react-reverse-portal'
import { MainNav } from '../../core'
import { ReusedInnerSettingsNav } from './settings-nav'

export interface SettingsWrapperProps {
	children?: ReactNode
}

export const SettingsNavContext = createContext<{ settingsNavTargetNode: HtmlPortalNode | null }>({
	settingsNavTargetNode: null,
})

export function SettingsWrapper({ children }: SettingsWrapperProps) {
	// Passing down the reused inner settings nav. This lets us nicely animate the active state.
	const portalNode = useMemo(() => createHtmlPortalNode(), [])
	const value = useMemo(() => ({ settingsNavTargetNode: portalNode }), [portalNode])

	return (
		<MainNav activeMainNavLink="settings">
			<div className="min-h-0 grid grid-rows-[auto_1fr] bg-white">
				<InPortal node={portalNode}>
					<ReusedInnerSettingsNav />
				</InPortal>
				<SettingsNavContext.Provider value={value}>
					{children}
				</SettingsNavContext.Provider>
			</div>
		</MainNav>
	)
}
